export const GET_KINDERGARTEN_APPROVALS = 'GET_KINDERGARTEN_APPROVALS';
export const SET_KINDERGARTEN_APPROVALS = 'SET_KINDERGARTEN_APPROVALS';
export const ADD_KINDERGARTEN_APPROVAL = 'ADD_KINDERGARTEN_APPROVAL';
export const SET_KINDERGARTEN_APPROVAL = 'SET_KINDERGARTEN_APPROVAL';
export const CREATE_KINDERGARTEN_APPROVAL = 'CREATE_KINDERGARTEN_APPROVAL';
export const REMOVE_KINDERGARTEN_APPROVAL = 'REMOVE_KINDERGARTEN_APPROVAL';
export const DELETE_KINDERGARTEN_APPROVAL = 'DELETE_KINDERGARTEN_APPROVAL';
export const UPDATE_KINDERGARTEN_APPROVAL_STATUS = 'UPDATE_KINDERGARTEN_APPROVAL_STATUS';
